import { io } from "socket.io-client";
import { env } from "../runtimeConfig";
import { HOST } from "../constants";

// Defaults to the API host: in every deployment so far the socket and the API
// are the same origin, so this only needs setting when they diverge.
const SOCKET_URL = env("REACT_APP_SOCKET_URL", HOST);

export const socket = io(SOCKET_URL, {
    autoConnect: false,
    transports: ["websocket"],
});
